import React from "react";
import Layout from "./layout";
import { useMetadata } from "../seo";

export function CommercialPage({ meta, children }) {
  useMetadata(meta.title, meta.path, meta.description);
  return (
    <Layout>
      <div className="commercial-page">{children}</div>
    </Layout>
  );
}
export function PageIntro({ label, title, children }) {
  return (
    <section className="container page-intro">
      <p className="eyebrow">{label}</p>
      <h1>{title}</h1>
      <p className="hero-description">{children}</p>
    </section>
  );
}
export function SectionNav({ links }) {
  return (
    <nav className="container section-nav" aria-label="On this page">
      {links.map(([href, label]) => (
        <a className="text-link" key={href} href={href}>
          {label}
          <span aria-hidden="true">↓</span>
        </a>
      ))}
    </nav>
  );
}
export function ContactCTA({
  title,
  children,
  label = "Discuss your project",
  href = "/contact",
}) {
  return (
    <section className="contact-section">
      <div className="container contact-grid">
        <div>
          <p className="eyebrow">Start a conversation</p>
          <h2>{title}</h2>
          <p>{children}</p>
        </div>
        <div className="contact-details">
          <a className="button" href={href}>
            {label}
            <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}
export function ProcessSteps({ steps }) {
  return (
    <ol className="process-steps">
      {steps.map(([title, description, note], index) => (
        <li key={title}>
          <span className="service-number" aria-hidden="true">
            {String(index + 1).padStart(2, "0")}
          </span>
          <div>
            <h3>{title}</h3>
            {note && <p className="step-note">{note}</p>}
            <p>{description}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
